import React from 'react';

interface IProps {
    checked?: boolean;
    className?: string;
    label?: string;
    name?: string;
    onBlur?: (event: any) => void;
    onChange?: (event: any) => void;
    value?: number | string;
}

class Radio extends React.Component<IProps> {
    public render(): JSX.Element {
        const { checked, className = '', label, value } = this.props;

        return (
            <div className={`form-check form-check-inline radio ${className}`}>
                <label>
                    <input
                        type='radio'
                        className='form-check-input'
                        checked={checked}
                        name={name}
                        onBlur={this.props.onBlur}
                        onChange={this.props.onChange}
                        value={value}
                    />
                    <span className='checkmark' />
                    {label}
                </label>
            </div>
        );
    }
}

export default Radio;
